import mixpanel from 'mixpanel-browser'
import type { AnalyticsProvider } from '../types'

type CreateMixpanelOptions = {
  token?: string
  superProperties?: Record<string, any>
}

export function createMixpanelProvider(options: CreateMixpanelOptions): AnalyticsProvider | null {
  const { token, superProperties } = options
  if (!token) return null

  mixpanel.init(token, { debug: false, track_pageview: false })
  if (superProperties && Object.keys(superProperties).length > 0) {
    mixpanel.register(superProperties)
  }

  return {
    async trackEvent(name: string, properties?: Record<string, any>): Promise<void> {
      mixpanel.track(name, properties)
    },

    async identifyUser(userId: string, traits?: Record<string, any>): Promise<void> {
      if (!userId) return
      mixpanel.identify(userId)

      if (!traits) return

      const {
        email,
        firstName,
        lastName,
        building,
        interests,
        receiveNotifications,
        roomNumber,
        acceptedTermsAndConditions,
        buildingId,
        buildingName,
      } = traits as Record<string, any>

      const interestNames = Array.isArray(interests)
        ? interests.map((i: any) => (typeof i === 'string' ? i : i?.name)).filter(Boolean)
        : undefined

      const peopleProps: Record<string, any> = {
        $email: email,
        $first_name: firstName,
        $last_name: lastName,
        building_name: buildingName ?? building,
        building_id: buildingId,
        interests: interestNames,
        receiveNotifications,
        roomNumber,
        acceptedTermsAndConditions,
      }

      const cleaned: Record<string, any> = {}
      Object.entries(peopleProps).forEach(([k, v]) => {
        if (v !== undefined) cleaned[k] = v
      })

      if (Object.keys(cleaned).length > 0) {
        mixpanel.people.set(cleaned)
      }
    },

    async registerSuperProperties(properties: Record<string, any>): Promise<void> {
      mixpanel.register(properties)
    },

    async resetUser(): Promise<void> {
      mixpanel.reset()
    },
  }
}


